import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureSiteImageProxyOrigin } from '@web-studio/core-components';
import { App, bootstrapSandboxTheme } from './App';
import { mountSandboxBridge } from './bridge';
import { resolveConfiguredShellOrigin } from './bridge/shellOrigin';
import { postSandboxReadyToShell } from './utils/postSandboxReady';
import './index.css';

// Production sandbox has no /api/site-image — point media proxy at studio-shell.
configureSiteImageProxyOrigin(resolveConfiguredShellOrigin());

bootstrapSandboxTheme();
mountSandboxBridge();
postSandboxReadyToShell();

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
